/* eslint-disable prefer-destructuring */
/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
import { AnyAction, Reducer } from 'redux';

export interface IMint {
  minting: boolean;
  step: number;
  progress: {
    ratio: number;
    current: number;
    total: number;
  };
}

export const initialState: IMint = {
  minting: false,
  // 0 encoding
  // 1 upload ipfs
  // 2 sign transaction
  // 3 success
  // 4 error
  step: 0,
  progress: { ratio: 0, current: 0, total: 0 },
};

export enum actions {
  MINT_TOGGLE = 'MINT_TOGGLE',
  MINT_STEP_CHANGE = 'MINT_STEP_CHANGE',
  MINT_FILE_PROGRESS = 'MINT_FILE_PROGRESS',
}

export const reducer: Reducer<IMint, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case actions.MINT_TOGGLE:
      return {
        ...state,
        minting: action.payload,
      };
    case actions.MINT_STEP_CHANGE:
      return {
        ...state,
        step: action.payload.step,
      };
    case actions.MINT_FILE_PROGRESS:
      return {
        ...state,
        progress: { ...action.payload },
      };
    default:
      return state;
  }
};
